import $ from 'jquery'
import ImageLoopController from './lib/image-loop-controller'
import ScreenSizeSubjectRepository from './common-util/responsive/screen-size-subject-repository'
// import listenPresentationTemplateActive from './lib/listen-presentation-template-active'

export default function initHeroSlideshows (breakpointUtils) {
  $(() => {
    // Responsive size settings, create aspect ratio subject
    // If changing sizes/aspects here, also update it in CSS
    const heroLogoAspect = 574 / 512
    const heroVisualAspect = 3 / 4
    const heroLogoAlignment = 0.549

    const heroCompositionAspect =
      heroLogoAspect +
      heroVisualAspect -
      heroLogoAspect * (1 - heroLogoAlignment)
    const screenSizeSubjectRepository = new ScreenSizeSubjectRepository()
    const minAspectRatioSubject = screenSizeSubjectRepository.getMinAspectRatioSubject(
      heroCompositionAspect
    )

    $('.hero__slideshow').each((i, el) => {
      console.log('hero', el)
      let presentationElement = el

      const imageLoopController = new ImageLoopController({
        containerElement: presentationElement,
        interval: 1000,
        transitionDuration: 300
      })

      imageLoopController.eventEmitter.on('slideWillBeNext', slide => {
        console.log('slide', slide)
        $(slide)
          .find('.lazyload')
          .addClass('lazypreload')
      })

      imageLoopController.init()

      // Start/stop depending on screen aspect ratio
      if ($(presentationElement).closest('.hero--desktop').length) {
        minAspectRatioSubject.subscribe(isActive => {
          console.log('isactive', isActive)
          if (isActive) {
            console.log('start desktop')
            imageLoopController.start()
          } else {
            console.log('stop desktop')
            imageLoopController.stop()
          }
        })
      } else if ($(presentationElement).closest('.hero--mobile').length) {
        minAspectRatioSubject.subscribe(isActive => {
          console.log('isactive', isActive)
          if (isActive) {
            console.log('stop mobile')
            imageLoopController.stop()
          } else {
            console.log('start mobile')
            imageLoopController.start()
          }
        })
      } else {
        imageLoopController.start()
      }

      // Activate / deactivate depending on breakpoints
      // let breakpointsManaged = listenPresentationTemplateActive(
      //   breakpointUtils,
      //   presentationElement,
      //   isActive => {
      //     if (isActive) {
      //       console.log('activate slideshow')
      //       imageLoopController.start()
      //     } else {
      //       console.log('deactivate slideshow')
      //       imageLoopController.stop()
      //     }
      //   }
      // )

      // if (!breakpointsManaged) {
      //   console.log('not managed')
      //   imageLoopController.start()
      // }
    })
  })
}
